import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { DirtyFormService } from "../services/dirty-form.service";

export interface CanBeDirty{
    isDirtyFn: () => Promise<boolean>;
}

@Injectable({
    providedIn: "root"
})
export class DirtyGuard  {
    private readonly router = inject(Router);
    private readonly dirtyFormService = inject(DirtyFormService);

    // eslint-disable-next-line sonarjs/function-return-type
    canDeactivate(component: CanBeDirty, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot) {
        // Hämtar state från navigate i DirtyFormService för att undvika att applikationen fastnar i en route canDeactivate loop
        const navigationState = this.router.currentNavigation()?.extras.state;
        const dirtyResolved: boolean = navigationState?.dirtyResolved;

        // Används t.ex. vid 403 då osparade ändringar ändå inte kan sparas
        if (navigationState?.skipDirtyCheck) {
            return true;
        }

        if(!dirtyResolved && !this.dirtyFormService.tryExit(currentState, nextState)) {
            return false;
        }

        if(!component?.isDirtyFn) {
            return true;
        }

        return component.isDirtyFn();
    }
}
